import { NgClass } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { SharedModule } from 'primeng/api'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { ButtonModule } from 'primeng/button'
import { InputTextModule } from 'primeng/inputtext'
import { MultiSelectModule } from 'primeng/multiselect'
import { SelectModule } from 'primeng/select'

import { GenericModule } from '@app/components/generic/generic.module'
import { RequiredFieldTextComponent } from '@app/components/metadata/required-field-text.component'

import { ActivityFieldComponent } from './activity-field.component'
import { AssetCategoriesFieldComponent } from './asset-categories-field.component'
import { BalzacBookFieldComponent } from './balzac-book-field.component'
import { BudgetLinesFieldComponent } from './budget-line-field.component'
import { CountryFieldComponent } from './country-field.component'
import { LandlordFieldComponent } from './landlord-field.component'
import { PartnerFieldComponent } from './partner-field.component'
import { PlaceFieldComponent } from './place-field.component'
import { ProgramPlaceFieldComponent } from './program-place-field.component'
import { ProjectContractsFieldComponent } from './project-contracts-field.component'
import { SupplierFieldComponent } from './supplier-field.component'
import { ThirdPartyCodeFieldComponent } from './third-party-code-field.component'
import { VoucherCodeFieldComponent } from './voucher-code-field.component'

@NgModule({
  imports: [
    FormsModule,
    SharedModule,
    ButtonModule,
    InputTextModule,
    AutoCompleteModule,
    MultiSelectModule,
    SelectModule,
    NgClass,
    GenericModule,
    ActivityFieldComponent,
    AssetCategoriesFieldComponent,
    BalzacBookFieldComponent,
    BudgetLinesFieldComponent,
    CountryFieldComponent,
    LandlordFieldComponent,
    PlaceFieldComponent,
    ProgramPlaceFieldComponent,
    ProjectContractsFieldComponent,
    SupplierFieldComponent,
    ThirdPartyCodeFieldComponent,
    VoucherCodeFieldComponent,
    PartnerFieldComponent,
    RequiredFieldTextComponent,
  ],
  exports: [
    ActivityFieldComponent,
    AssetCategoriesFieldComponent,
    BalzacBookFieldComponent,
    BudgetLinesFieldComponent,
    CountryFieldComponent,
    LandlordFieldComponent,
    PlaceFieldComponent,
    ProgramPlaceFieldComponent,
    ProjectContractsFieldComponent,
    SupplierFieldComponent,
    ThirdPartyCodeFieldComponent,
    VoucherCodeFieldComponent,
    PartnerFieldComponent,
    RequiredFieldTextComponent,
  ],
})
export class FieldsModule {}
